import { HardwareSupplierFilterKeyType, SUPPLIER_INTEGRATION_TYPES } from 'opensolar-common'
import { useGetSupplierConfig } from './useGetSupplierConfig'

/**
 * Determines whether the supplier uses a price-on-application-with-tiers model
 * AND the component has no price tiers assigned (no org-price tier association).

 * @param supplierFilterKey - The supplier filter key of the selected distributor.
 * @param price - The resolved price for the component from this supplier.
 * @returns true if the supplier is PRICE_ON_APPLICATION_WITH_TIERS and price is empty.
 */
const useIsTieredPriceOnApplication = (
  supplierFilterKey: HardwareSupplierFilterKeyType | undefined,
  price: number | null | undefined
): boolean => {
  const { getSupplierConfig } = useGetSupplierConfig()

  if (!supplierFilterKey || supplierFilterKey === 'component') return false
  const integrationType = getSupplierConfig(supplierFilterKey)?.integrationType
  return integrationType === SUPPLIER_INTEGRATION_TYPES.PRICE_ON_APPLICATION_WITH_TIERS && !price
}

export default useIsTieredPriceOnApplication
